import { CardTransactionDTO } from 'core/api';

import { CardTransactionMetadata, Platform } from 'pos/common';
import { Result, SessionProvider } from 'core/infrastructure';


import CordovaPinpad from './CordovaPinpad';
import ElectronPinpad from './ElectronPinpad';
import { Pinpad } from './Pinpad';

function getPinpad(): Pinpad {
	switch (Platform.getType()) {
		case 'Electron':
			return ElectronPinpad;
		case 'Cordova':
			return CordovaPinpad;
		default:
			throw Error(`La plataforma ${Platform.getType()} no soporta pagos con tarjeta`);
	}
}

export type TransactionRequest = { transactionId: string, type: string, amount: number, askGratuity: boolean, relatedTransactionXmlDetails?: string }

export async function transact(transaction: TransactionRequest): Promise<Result<CardTransactionDTO>> {

	assertUseCardProcessor();

	const session = SessionProvider.getCurrent();
	const metadata: CardTransactionMetadata = {
		transactionType: transaction.type,
		userReference: `${session.UserId}-${session.UserName}`,
		posReference: `${session.PosId}-${session.PosName}`,
		relatedTransactionXmlDetails: transaction.relatedTransactionXmlDetails || '',
		askGratuity: transaction.askGratuity
	};

	return await getPinpad().transact(transaction.transactionId, transaction.amount, metadata);
}

function assertUseCardProcessor() {
	const session = SessionProvider.getCurrent();
	if (!session.UseCardProcessor)
		throw new Error('No se puede utilizar un CardProcessor si no hay pinpad configurado');
}